module.exports = __webpack_public_path__ + "static/media/leatherpatch.1f7c2412.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/leatherpatch.png
// module id = 1105
// module chunks = 0